import cn from 'classnames';
import type React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import PhoneInput from 'react-phone-input-2';
import ru from 'react-phone-input-2/lang/ru.json';
import type { CartValues } from '@shared/types/cart';
import { useClientData } from './model';
import * as st from './styles.module.scss';

export const Client: React.FC = () => {
  const client = useClientData();
  const { control } = useFormContext<CartValues>();

  return (
    <div className={st.client}>
      <Controller
        control={control}
        name="last_name"
        render={({ field, fieldState: { error } }) => (
          <div className={cn(st.wrapper, error && st.error)}>
            <label htmlFor="last_name" className={st.requared}>
              Фамилия*
            </label>
            <input
              id="last_name"
              type="text"
              value={field.value !== null ? field.value : ''}
              ref={field.ref}
              onChange={(e: any) => {
                field.onChange(e.target.value);
                client.client.last_name &&
                  client.handleChange(e.target.value, 'last_name', client.client);
              }}
            />
          </div>
        )}
        defaultValue={client.last_name !== null ? client.last_name : ''}
      />

      <Controller
        control={control}
        name="first_name"
        render={({ field, fieldState: { error } }) => (
          <div className={cn(st.wrapper, error && st.error)}>
            <label htmlFor="first_name" className={st.requared}>
              Имя*
            </label>
            <input
              id="first_name"
              type="text"
              value={field.value}
              ref={field.ref}
              onChange={(e: any) => {
                field.onChange(e.target.value);
                client.handleChange(e.target.value, 'first_name', client.client);
              }}
            />
          </div>
        )}
        defaultValue={client.first_name !== null ? client.first_name : ''}
      />

      <Controller
        control={control}
        name="middle_name"
        render={({ field, fieldState: { error } }) => (
          <div className={cn(st.wrapper, error && st.error)}>
            <label htmlFor="middle_name">Отчество</label>
            <input
              id="middle_name"
              type="text"
              value={field.value}
              ref={field.ref}
              onChange={(e) => {
                field.onChange(e.target.value);
                client.handleChange(e.target.value, 'middle_name', client.client);
              }}
            />
          </div>
        )}
        defaultValue={client.middle_name || ''}
      />

      <div className={st.phone}>
        <Controller
          name="phone"
          render={({ field: { value, onChange, onBlur, ref }, fieldState: { error } }) => {
            return (
              <div className={cn(st.wrapper, error && st.error)}>
                <label
                  className={cn(st.label__PhoneInput, st.requared, error && st.error)}
                  htmlFor="phone"
                >
                  Телефон*
                </label>
                <PhoneInput
                  placeholder="+7 (000) 000-00-00"
                  country={'ru'}
                  value={value}
                  onChange={(value) => {
                    onChange(value);
                    client.handleChange(value, 'phone', client.client);
                  }}
                  localization={ru}
                  inputClass={cn(st.input__PhoneInput, error && st.error)}
                  specialLabel=""
                  containerClass={st.wrapper__PhoneInput}
                  inputProps={{ ref: ref }}
                />
              </div>
            );
          }}
          control={control}
          defaultValue={client.phone}
        />
      </div>

      <Controller
        control={control}
        name="email"
        render={({ field, fieldState: { error } }) => (
          <div className={cn(st.wrapper, error && st.error)}>
            <label htmlFor="email" className={st.requared}>
              Электронная почта*
            </label>
            <input
              id="email"
              type="text"
              value={field.value}
              ref={field.ref}
              onChange={(e: any) => {
                field.onChange(e);
                client.handleChange(e.target.value, 'email', client.client);
              }}
            />
          </div>
        )}
        defaultValue={client.email}
      />
    </div>
  );
};
